import { useParams } from "react-router";
import { Redirect } from "react-router-dom";
import { AuthConsumer } from "./AuthProvider";

export const OnBehalfOf = () => {
    const { physicianId } = useParams<any>();

    return (
        <AuthConsumer>
            {({ setOnBehalfOf }) => {
                setOnBehalfOf(physicianId)
                return <Redirect to="/" ></Redirect>;
            }}
        </AuthConsumer>
    );
};